/**
* Gifttagg v3
*/
let generatedMessage = "";
const handleGenerateGiftnote = function (gifttagg,  magicWriter) {   
  var message = ""
    if(gifttagg !== undefined && magicWriter === undefined){
      message = gifttagg.firstName + ' ' + gifttagg.lastName + ' has sent you a very special video / voice message. To play, visit play.gifttagg.com & enter message code: ' + gifttagg.code
    } else if(gifttagg === undefined && magicWriter !== undefined){
       message = magicWriter.message
    } else if (gifttagg !== undefined && magicWriter !== undefined) {
       message = magicWriter.message + '\n\n' + gifttagg.firstName + ' ' + gifttagg.lastName + ' has sent you a very special video / voice message. To play, visit play.gifttagg.com & enter message code: ' + gifttagg.code
    }

  ((message == "") && window.sessionStorage.removeItem('giftMessage'))
  /*if(message == ""){
    (window.sessionStorage.getItem('giftMessage') && window.sessionStorage.removeItem('giftMessage'));
  }else{
    ((message != "") && window.sessionStorage.setItem('giftMessage',btoa(message)));
  }*/
  // updateCartItems(message)

  return message
}

const config = {
  widget: {
    containerId: 'magic-writer-element',
    generateGiftnote: handleGenerateGiftnote
  },
  magicWriter: {
    magicWriterMaxChars: 300,
    maxGenerations: 10,
    homePage: {
      disabled: true,
      includeGiftNoteInWidget: true,
      generateButtonVisible: true,
      dividerVisible: true,
      gifttaggVisible: true,
      placeHolderForEmbedGiftNote:"Hyy There"
    },
    formPage: {
      titleVisible: true,
      disableToField: false,
      disableFromField: false
    },
    theme: {
      accentColor: 'linear-gradient(90deg,var(--red),var(--pink))'
    },
    overrides:{
      overrideWidth: '100%'
    }
  },
  gifttagg: {
    functionality: {
      recordLaterEnabled: false
    },
    theme: {
      name: 'default'
    }
  }
};


let giftingElement = document.getElementById('magic-writer-element');
// let giftNoteTextareaElement = document.querySelector('.js-gift-note-text');
let giftNoteTextareaElement = document.querySelector('.sc-gEvEer.lfvJfN');

if(giftingElement){
  const callback = (mutationList, observer) => {
    // console.log(mutationList);
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        // console.log("A child node has been added or removed.",mutation);
        mutation.addedNodes.forEach(node => {
          if(node.className == "filledButton-0-2-19 filledButton-d1-0-2-25"){
            node.style.display = "none";
            // giftNoteTextareaElement.style.display = "block";
          }
          
          if(node.className == "sc-aXZVg ecdNcC" ){
            console.log('node',node)
            let textValue = node.querySelector('textarea').value;
            generatedMessage = textValue;
            // document.querySelector('.freshie__image').style.display = "block";
            document.querySelector('.js-gift-note-text').style.display = "block";
            document.querySelector('.js-gift-note-text').value = textValue;
            document.querySelector('.freshie__image').style.display = "none";
            
            // giftNoteTextareaElement.value;
            // giftNoteTextareaElement.value = textValue;
            // node.querySelector('textarea').style.display = "none";
            // giftNoteTextareaElement.style.display = "block";
          }
          if(node.id == "magic-app"){
            node.querySelector('.title-0-2-10 b').innerText = "Freshie";
          }
        });
        // console.log(mutation.target.value)

        if(mutation.target.value != '' && mutation.target.value != undefined && mutation.target.value != null){
          document.querySelector('.js-gift-note-text').style.display = "block";
          document.querySelector('.js-gift-note-text').value = mutation.target.value;
        }
        
        // if(mutation.target.className == "sc-dcJsrY iRnkpC"){
        //   generatedMessage = mutation.target.value;
        //   giftNoteTextareaElement.value = mutation.target.value;
        // }
      }
    }
  };
  const observer = new MutationObserver(callback);

  observer.observe(giftingElement, { attributes: true, childList: true, subtree: true })
  
  var sdk = gifttaggSDK.Build(config);  
  // giftNoteTextareaElement.oninput = () => {
  //   let textArea = document.querySelector('.sc-aXZVg.ecdNcC textarea');
  //   textArea.value = giftNoteTextareaElement.value;
  //   generatedMessage = giftNoteTextareaElement.value;
  // }
}

function openGiftTag() {
  sdk.gifttagg.open();
}

function storeMessage() {
  window.sessionStorage.setItem("giftMessage",btoa(generatedMessage));
}

var freshieImage = document.querySelector('.freshie__guy-image');
if(freshieImage){
freshieImage.addEventListener('click', function(element) {
  freshieImage.parentElement.style.opacity = 1;
}, false);
  
}

let toggleFreshieGuy = () => {
  if(document.querySelector('.section-gift-form')){
  const giftSection = document.querySelector('.section-gift-form'),
        rect = giftSection.getBoundingClientRect();
  giftSection.querySelector('.gift__form-right').classList.toggle('visible',((rect.top - (rect.height - 500)) <= 0))
    
  }
}

window.onscroll = toggleFreshieGuy;
// toggleFreshieGuy();


/*async function updateCartItems(giftMessage) {
  var cartContents = await fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(data => { return data });

  if (cartContents.items.length > 0) {
    var updateItems = [];
    cartContents.items.forEach(async (item, index) => {
      if (item.id != '42182325993645') { 
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({'id': item.key, 'quantity': item.quantity, 'properties': {"Message": giftMessage} })
        })
        .then(response => response.json())
        .then(data => { return data });
      }
    });
  }
}*/